import { LogoImageProps } from '../'

export const AppBwinLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/bwin.svg',
    width: 42,
    height: 14,
}

// TODO: Currently we do not have any logos for darkmode on web
export const AppDarkBwinLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/bwin.svg',
    width: 42,
    height: 14,
}

export const AppHpybetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/hpybet_mobile.svg',
    width: 20,
    height: 20,
}

export const AppInterwettenLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/iw_mobile.svg',
    width: 40,
    height: 20,
}

export const AppTipicoLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/tipico_mobile.svg',
    width: 15,
    height: 20,
}

export const AppUnibetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/unibet_mobile.png',
    width: 20,
    height: 20,
}

export const AppNeoBetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/bwin.svg',
    width: 43,
    height: 15,
}

// TODO: Currently we do not have any logos for darkmode on web
export const AppDarkNeoBetLogo: LogoImageProps = {
    source: 'https://images.sport1.de/partners/betting/bwin.svg',
    width: 43,
    height: 15,
}
